/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 8/25/20
 *
 */

const FormElementType = Object.freeze({
	FULL_NAME: 'FULL_NAME',
	EMAIL_ADDRESS: 'EMAIL_ADDRESS',
	MULTILINE: 'MULTILINE',
	TEXT: 'TEXT',
	DATE: 'DATE',
	CHECKBOXES: 'CHECKBOXES',
	RADIOBUTTONS: 'RADIOBUTTONS',
	DROP_DOWN: 'DROP_DOWN',
	TITLE: 'TITLE',
	FOOTER: 'FOOTER',
	SCORE_RESULT: 'SCORE_RESULT',
	SCORE_BUCKET_RESULT: 'SCORE_BUCKET_RESULT',
	ADDRESS: 'ADDRESS',
	PHONE_NUMBER: 'PHONE_NUMBER',
	DATE_OF_BIRTH: 'DATE_OF_BIRTH',
	EMERGENCY_CONTACTS: 'EMERGENCY_CONTACTS',
	CONTACT_INFO: 'CONTACT_INFO',
	TEXT_GRID: 'TEXT_GRID',
})

export default FormElementType

